import * as types from './quartal.types';
import * as constants from './quartal.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeQuartal = generateStoreResourceAction<types.IQuartal>(constants.STORE_QUARTAL);
export const clearQuartal = generateClearResourceAction(constants.CLEAR_QUARTAL);
